<template>
  <div class="page-markets">
    <template v-if="isLayoutDesktop">
      <div class="page-markets__desktop-header">
        <div v-if="showInitialSpinner" class="page-markets__desktop-header-skeleton">
          <div
            class="page-markets__desktop-header-line page-markets__desktop-header-line--title"
          ></div>
          <div class="page-markets__desktop-header-filters">
            <div
              class="page-markets__desktop-header-line page-markets__desktop-header-line--label"
            ></div>
            <div class="page-markets__desktop-header-chip"></div>
            <div class="page-markets__desktop-header-chip"></div>
            <div class="page-markets__desktop-header-chip"></div>
          </div>
        </div>
        <template v-else>
          <market-list-desktop-header
            ref="desktopHeader"
            :title="currentHeaderName"
            :count="filteredMarkets.totalCount"
            :layout="marketDisplay"
            :embedded="embedded"
            @toggle="onLayoutToggle"
          ></market-list-desktop-header>
        </template>
      </div>
    </template>
    <div class="page-markets__mobile-header-wrapper" v-else>
      <div class="page-markets__mobile-header-container">
        <div v-if="showInitialSpinner" class="page-markets__mobile-header-skeleton">
          <div
            class="page-markets__mobile-header-line page-markets__mobile-header-line--title"
          ></div>
          <div class="page-markets__mobile-header-line"></div>
        </div>
        <template v-else>
          <market-section-header
            ref="mobileHeader"
            class="page-markets__mobile-header"
            :title="currentHeaderName"
            :count="filteredMarkets.totalCount"
            :embedded="embedded"
          ></market-section-header>
          <market-filters-mobile class="page-markets__mobile-filters" :embedded="embedded">
          </market-filters-mobile>
        </template>
      </div>
    </div>
    <div
      ref="loadPreviousSentinel"
      class="page-markets__load-more-sentinel"
      v-if="filteredMarkets.canLoadPrevious && marketsPageInitialLoadDone"
    >
      <div class="page-markets__spinner" v-if="isLoadingPrevious && showSpinner"></div>
    </div>
    <div class="page-markets__grid page-markets__grid--loading" v-if="showInitialSpinner">
      <div class="page-markets__grid-item" v-for="index in marketSkeletonCount" :key="index">
        <div class="page-markets__skeleton-card">
          <div class="page-markets__skeleton-card-inner">
            <div class="page-markets__skeleton-image"></div>
            <div class="page-markets__skeleton-main">
              <div class="page-markets__skeleton-title"></div>
              <div
                class="page-markets__skeleton-contract page-markets__skeleton-contract--primary"
              ></div>
              <div class="page-markets__skeleton-contract"></div>
              <div class="page-markets__skeleton-meta"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-markets__grid" v-else-if="items.length > 0">
      <div
        class="page-markets__grid-item"
        v-for="item in items"
        :data-page-boundary="item.pageBoundary || null"
      >
        <market-list-item
          :watchIcon="item.isMarketWatched"
          :key="item.marketId"
          :layout="marketDisplay"
          :market="item"
        ></market-list-item>
      </div>
    </div>
    <router-link
      v-if="nextPageRouteLocation"
      :to="nextPageRouteLocation"
      class="page-markets__next-page-link"
    >
      Next Page
    </router-link>
    <div
      ref="loadMoreSentinel"
      class="page-markets__load-more-sentinel"
      v-if="filteredMarkets.canLoadMore && marketsPageInitialLoadDone"
    >
      <div class="page-markets__spinner" v-if="isInfiniteLoading && showSpinner"></div>
    </div>
    <div class="page-markets__no-markets-found" v-if="showNoMarketsMessage">
      No Markets Found. <br />
      Please Adjust Filters
    </div>
  </div>
</template>

<script src="./page-markets.js"></script>
<style src="./page-markets.scss" lang="scss"></style>
